// Conditionally import ONLY the needed config
// This prevents both configs from being initialized at the same time
const getFirebaseConfig = () => {
  // Check if running in browser
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    
    // Production domains
    const isProductionDomain = 
      hostname === "itsyourstory.co.in" ||
      hostname === "www.itsyourstory.co.in" ||
      hostname === "its-your-story.web.app" ||
      hostname === "its-your-story.firebaseapp.com";
    
    if (isProductionDomain) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      return require("./firebase.prod").default;
    }
    
    // Everything else is development (localhost, etc.)
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require("./firebase.dev").default;
  }
  
  // Fallback for SSR or non-browser environments (shouldn't happen with CRA)
  // Use environment variables as fallback
  const envCheck = process.env.REACT_APP_ENV ?? process.env.NODE_ENV ?? "development";
  if (envCheck === "production") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require("./firebase.prod").default;
  }
  
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  return require("./firebase.dev").default;
};

const firebase = getFirebaseConfig();

export const { auth, googleProvider, db, storage, analytics, perf } = firebase;

export default firebase;
